/**
* method
* headers
* body GET 不可以 POST 可以
* mode
* credentials
* eg...
*/

export default {
  method: 'GET', // 默认 GET ; POST
  credentials: 'omit' // 默认 omit 不带 cookie, 改为 include 带 cookie
}



// WEBPACK FOOTER //
// ./src/plugins/fetch/config.js